// extracted by mini-css-extract-plugin
module.exports = {"badge-button":"_1ORc1","badgeButton":"_1ORc1","badge":"OgeXE"};